<template>
  <div>
    <router-view />
    <modal-states
      id="modalStateGlobal"
      ref="modalStateGlobal"
      @hide="onHideModalState()"
    />
    <span v-if="userLoggedIn">
      <modal-user-downtime
        id="modalUserDowntime"
        ref="modalUserDowntime"
      />
    </span>
  </div>
</template>

<script>

import { auth } from '@/api/auth'
import ModalStates from '@/components/modals/ModalStates'
import ModalUserDowntime from '@/components/modals/ModalUserDowntime'

export default {
    name: 'App',
    components: {
        ModalStates,
        ModalUserDowntime
    },
    computed: {
        userLoggedIn() {
            return this.$store.getters.userLoggedIn
        },
        modalStateMessage() {
            return this.$store.getters.modalStateMessage
        },
        modalUserDowntime() {
            return this.$store.getters.showUserDowntimeModal
        }
    },
    watch: {
        modalStateMessage(modalStateMessage) {
            if (modalStateMessage) {
                this.$refs.modalStateGlobal.show(
                    modalStateMessage.message,
                    modalStateMessage.icon,
                    modalStateMessage.state,
                    modalStateMessage.hideAutomatically)
            }
        },
        modalUserDowntime(newValue) {
            if (this.userLoggedIn) {
                if (newValue) {
                    const timeToDowntimeInSeconds = auth.getCountdownToCloseSessionInSeconds()
                    this.$refs.modalUserDowntime.show(timeToDowntimeInSeconds)
                } else {
                    this.$refs.modalUserDowntime.cancelCountDownInterval()
                }
            }
        }
    },
    created() {
        this.addTheme()
    },
    methods: {
        addTheme() {
            const body = document.body
            body.classList.add('theme-default')
        },
        onHideModalState() {
            this.$store.commit('updateModalStateMessage', null)
        }
    }
}

</script>

<style lang="css">
.fade-enter-active,
.fade-leave-active {
    transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>
